import React from 'react';

var DefaultOptionComponent = function DefaultOptionComponent(_ref) {
  var option = _ref.option;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, option.text)
  );
};

export { DefaultOptionComponent };